const getters = {
  orders: (state) => state.user.orders.edges
};
export default getters;
